<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <Loading v-if="loading"/>
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
             

            <div class="col-auto">
                <card shadow class="card-profile mt--400 ml-5 mr-5" no-body>

                     <div class="row justify-content-center mb-5">
                    <div class="col-lg-3 order-lg-2">
                        <div class="card-profile-image">
                            <a href="#">
                                <img v-lazy="'img/chart.png'" class="rounded-circle bg-white">
                            </a>
                        </div>
                        
                    </div>
                    <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                        <div class="card-profile-actions py-4 mt-lg-0">
                            <a class="btn btn-primary float-right" href="/#/absent"><i class="ni ni-circle-08 nix3"></i> Absent Staff</a>
                        </div>
                    </div>
                    <div class="col-lg-4 order-lg-1">
                        <div class="card-profile-stats d-flex justify-content-center">
                            <h2 class="col-11 text-center font-weight-bold">LEAVE DAYS</h2>
                                
                        </div>
                    </div>
                </div>
                   <!-- <div class="card-header text-center">
                    <div class="row">
                    <h3 class="col-10">
                        Reports
                    </h3>
                     <a class="btn btn-warning col-2 float-right" href="/#/absent"><i class="ni ni-circle-08 nix3"></i> Absent Staff</a>
                    </div>

                   </div> -->

                   
                    <div class="p-4">
                        <div class="">
                            <div class="row justify-content-center mt-2">
                                    <div class="col-4">
                                    <label>Select Date Range To Filter Report :</label>
                                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                                        <flat-picker  slot-scope="{focus, blur}" 
                                                    @on-open="focus" 
                                                    @on-close="blur"                                                    
                                                    :config="{allowInput: true, mode: 'range'}"
                                                    class="form-control datepicker"
                                                    v-model="form.range">
                                        </flat-picker>
                                    </base-input>
                                    </div>

                                    <div class="col-4">
                                        <label>Champion Phone :</label>
                                        <base-input placeholder="2547XXXXXXXX" v-model="form.mobile"></base-input>
                                    </div>

                                    
                                    <div class="col-3">
                                        <label>Departments :</label>
                                        <b-select  v-model="form.dept">
                                            <b-select-option></b-select-option>
                                            <b-select-option v-for = "dept in depts" :key="dept.DepartmentID" :value="dept.DepartmentID"> {{ dept.Name }} </b-select-option>
                                        </b-select>
                                    </div>

                                    <div class="col mt-auto mb-auto text-center">
                                        <div v-if ="!loading" type="button" class="pointer icon icon-shape bg-gradient-primary rounded-circle text-white mb-3" v-on:click="fetchData"><i class="ni ni-cloud-download-95"></i></div>  
                                    </div>
                                  
                           
                                
                                
                            </div>

                            <div class="row justify-content-center mt-2">
                                 <div class="col">
                                    <table class="table table-striped" id="myTable">
                                    <thead>
                                        <tr>                                
                                            <th scope="col">Champion</th>
                                            <th scope="col">Champion Phone</th>
                                            <th scope="col">Department</th>
                                            <th scope="col">Type Of Leave</th>
                                            <th scope="col">Reason</th>
                                            <th scope="col">From Date</th>
                                            <th scope="col">To Date</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Days Approved</th>
                                            <th scope="col">Cancel</th>
                                     
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(staff,index) in leavedays" :key="index" >
                                       
                                        <td>
                                            {{ staff["rider.FullName"]}}
                                           
                                        </td>
                                        <td>{{ staff["rider.MobileNumber"]}}</td>
                                        <td>{{ staff["Department.Name"]}}</td>
                                        <td>                                            
                                            <span v-if="staff.LeaveType == 'CL'">Casual Leave</span>
                                            <span v-if="staff.LeaveType == 'SL'">Sick Leave</span>
                                            <span v-if="staff.LeaveType == 'PL'">Paternity Leave</span>
                                            <span v-if="staff.LeaveType == 'ML'">Maternity Leave</span>
                                        </td>
                                        <td>{{ staff.ReasonForLeave}}</td>
                                        <td>{{ moment(staff.FromDate).format("MMM Do YYYY h:mm a ")  }}</td>
                                        <td>{{ moment(staff.ToDate).format("MMM Do YYYY h:mm a" )}}</td>                                     
                                        <td>
                                            <badge :type='staff.Action === "Approved" ?  "success" : staff.Action === "Rejected" ?  "danger" : "primary" '>{{ staff.Action }}</badge >
                          
                                        </td>
                                        <td>{{  staff.DaysApproved }}</td>
                                        <td>                                           
                                            <b-button v-if="!staff.Action" variant="danger" @click="handleShow(staff)"> Cancel </b-button>                                              
                                          
                                        </td>
                         
                                        </tr>
                                  
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
               
            </div>
              <b-modal 
                id="reject-task-leave"
                ref="reject-task-leave"
                v-model="settings"               
                title= 'Reject Leave Application'
                @ok="handleOk"

            >
                <b-container fluid>
                <!-- <Loading v-if="loading"/> -->
                    <badge v-if="msg && !loading" type="warning">{{ msg }}</badge>
                    <b-form @submit.stop.prevent ="onSubmit" >
            
                    <b-form-group
                        id="input-group-1"
                        label="Reason:"
                        label-for="input-1"
                    
                    >
                        <b-form-input
                        id="input-1"
                        v-model="reason"
                        type="text"
                        placeholder="Enter Rejection Reason"
                        required
                        ></b-form-input>
                        <div class="text-danger text-center">
                            <span v-if="!$v.reason.required && $v.reason.$anyDirty">Reason is required</span>
                        </div>
                    </b-form-group>
                    
                    </b-form>
                </b-container>
            </b-modal>
       
        </section>
    </div>
</template>

<script>
import $ from 'jquery'
// import 'datatables.net-dt'

import '../../node_modules/datatables.net-buttons/js/jquery.dataTables.min.js'
import '../../node_modules/datatables.net-buttons/js/dataTables.buttons.js'
import '../../node_modules/datatables.net-buttons/js/jszip.min.js'
import '../../node_modules/datatables.net-buttons/js/pdfmake.min.js'
import '../../node_modules/datatables.net-buttons/js/vfs_fonts.js'
import '../../node_modules/datatables.net-buttons/js/buttons.html5.min.js'
import '../../node_modules/datatables.net-bs4/js/dataTables.bootstrap4.js'

import '../../node_modules/datatables.net-buttons-dt/css/buttons.dataTables.css'
import '../../node_modules/datatables.net-bs4/css/dataTables.bootstrap4.css'




import moment from "moment"
import _ from "lodash"
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from '../views/Loading.vue'
import humanizeDuration  from 'humanize-duration'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import { required } from 'vuelidate/lib/validators'

export default {

    components: { 
       flatPicker,
       Loading,
       LottieAnimation
    },

    data(){

        return{
            currentLeave:{},
            settings:false,
            loading:false,
            form: {
                range: `${moment().subtract("1","days").format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")} `,
                mobile:'',
            },
            reason:'',
            msg:'',
            timestamp:moment().format(),
            depts:this.$store.state.departments,
         
            
            
        }
    },

    mounted(){
        
        this.fetchData()
        
    },

    computed:{
        moment(){
              return moment
        },
          
        humanizeDuration(){
              return humanizeDuration
        },

        leavedays(){
            return this.$store.state.leavedays
        }
                
    },

    validations () {
        return {   
            reason: { required },       
        }
    },

    methods:{

         handleOk(bvModalEvt){

            bvModalEvt.preventDefault()
            this.handleSubmit()

        },

        handleShow(leave){
            this.$refs['reject-task-leave'].show()
            this.currentLeave = leave
        },

        handleSubmit(){
         this.$v.$touch();
         if(this.$v.$error) return
         
         this.loading = true
         this.msg = ''
         fetch(`${process.env.VUE_APP_APIURL}/attendance/reject/${this.currentLeave.LeaveID}`, 
            {
                method:'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization':this.$store.state.token
                },
                body : JSON.stringify({ "reason":this.reason , "user":this.$store.state.user.email })
            })
            .then(response => response.json())
            .then(data => {   

                if(data.success){
                    
                    this.fetchData(); 
                    this.msg = 'Leave application has been cancelled'             
    
                    setTimeout(() => {   
                
                      this.$refs['reject-task-leave'].hide('reject-leave-modal')
                     
                    }, 2000);            
                }
            })
            .catch(err => {
                setTimeout(() => {
                    this.loading=false
                    this.msg = 'Something went wrong.'      
                    this.$emit('changeError', 'Something went wrong.')
                }, 2000);
            });

           


      },

        getNow(){
            this.timestamp = moment().format();
        },
     
        startDownload(){
            this.loading = true;
        },
        finishDownload(){
            this.loading = false;
        },
       
        async fetchData(){             
             this.loading = true
            const response = await fetch(`https://stats.little.bz/attendance/leave/${this.$store.state.company.CorporateID}`, 
                {
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization':this.$store.state.token
                    },
                    body:JSON.stringify({ dept :this.form.dept, mobile:this.form.mobile  , fromdate:this.form.range.split("to")[0].trim() , todate:this.form.range.split("to")[1].trim() ? this.form.range.split("to")[1].trim() : this.form.range.split("to")[0].trim() })
                
                });                
                            
            const { leavedays } = await response.json();

            this.$store.dispatch('leavedays',leavedays);
            $('#myTable').DataTable().destroy();
            this.$nextTick().then(()=>$('#myTable').DataTable({
                        dom: 'Bfrtip',
                        buttons: [
                            'copyHtml5',
                            'excelHtml5',
                            'csvHtml5',
                            'pdfHtml5'
                        ]
            }));

            this.loading = false;
         
                    
        },

        getReport(){
            this.loading = true                
                
            this.$store.dispatch("getReport",{ dept :this.form.dept, mobile:this.form.mobile , fromdate:this.form.range.split("to")[0].trim() , todate:this.form.range.split("to")[1].trim() ? this.form.range.split("to")[1].trim() : this.form.range.split("to")[0].trim() })
            .then(() => {

                this.loading = false
                
                this.$nextTick(function() {                   
                    
                    $('#myTable').DataTable({
                                dom: 'Bfrtip',
                                buttons: [
                                    'copyHtml5',
                                    'excelHtml5',
                                    'csvHtml5',
                                    'pdfHtml5'
                                ],
                                bDestroy: true
                    
                    })               
             
                })    
                
            })
            .catch(() => {
                 this.loading = false    
            })
        }
     
        
    }
};
</script>

<style>

</style>
